import React from 'react';
export default class FormItemEditorRenderForAutoLookup extends React.Component
{
	constructor(props) {
		super(props);
		this.state = {recordValue:props.value};
	}

	getDisplay(_value)
	{
		if(_value == null || _value == undefined)
			_value = this.props.value;
		return _value;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/renders/FormItemEditorRenderForAutoLookup.js